import { Route, Routes } from "react-router-dom";
import { CryptoEditorPage } from "./pages";
import { AccountsPage } from "src/Modules/Predictions/pages/AccountsPage";

export const ConfigEditorRouter = () => {
  return (
    <Routes>
      <Route path="crypto" element={<CryptoEditorPage />} />
      <Route path="accounts" element={<AccountsPage />} />
    </Routes>
  );
};
